import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="center-panel">
      <h1>That page does not exist</h1>
      <p className="muted">The link may be old, or the project may have been deleted.</p>
      <Link to="/app/projects" className="button">
        Go to your projects
      </Link>
    </div>
  )
}
